<template>
  <div>
    <br />
    <div class="row">
      <div class="col-lg-6">
        <el-tabs type="card">
          <el-tab-pane v-for="type in campaignTypes" :key="type.type">
            <strong slot="label">{{ type.label }}</strong>
            <el-card>
              <campaign-filter-table
                @change="handleCampaignSelection"
                :campaigns="getCampaignsByType(type.type)"
              />
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div id="selected-campaigns" class="col-lg-6">
        <el-tabs type="card">
          <el-tab-pane>
            <strong slot="label">Selected Campaigns</strong>
            <el-card>
              <campaign-filter-table
                :empty-text="'No selected campaigns or surveys'"
                :selectorTable="false"
                :campaigns="selectedCampaigns"
              />
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import collect from 'collect.js';
import CampaignFilterTable from '@/components/profiles/filters/CampaignFilterTable';

export default {
  name: 'CampaignFilter',
  components: {
    CampaignFilterTable,
  },
  data: () => ({
    campaignTypes: [
      { type: 'competition', label: 'Competitions' },
      { type: 'survey', label: 'Surveys & Polls' },
      { type: '*', label: 'Campaigns' },
      { type: 'message_board', label: 'Message Boards' },
      { type: 'sampleset', label: 'Sample Sets' },
    ],
  }),
  computed: {
    selectedCampaigns() {
      return collect(this.campaigns)
        .where('selected', true)
        .all();
    },
  },
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleCampaignSelection() {
      this.$emit('filter', [
        'meta.campaign',
        this.selectedCampaigns.map(campaign => parseInt(campaign.id, 10)),
      ]);
    },
    getCampaignsByType(type) {
      if (type === '*') return this.campaigns;
      return collect(this.campaigns)
        .where('type', type)
        .put('selected', false)
        .all();
    },
    reset() {
      this.$refs.selections.map(selection => selection.reset());
    },
  },
};
</script>



// WEBPACK FOOTER //
// CampaignsFilter.vue?3c9226aa